<template>
  <li>
    <div class="item-content">
      <div class="item-inner">
        <div class="item-title">
          <slot name="title">
            <div
              v-if="title"
              class="item-title"
            >
              {{ title }}
            </div>
          </slot>
        </div>
        <div class="item-after">
          <div v-if="'right' in $slots">
            <slot name="right" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="'body' in $slots">
      <slot name="body" />
    </div>

    <div
      v-if="isSortable"
      class="sortable-handler"
    />
  </li>
</template>

<script setup>
// @ts-check

defineProps({
  /** The title of the item. */
  title: { type: String, default: null },

  /** Whether the item is sortable. */
  isSortable: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.item-title {
  display: flex;
  align-items: center;
}

.item-inner {
  &::after {
    content: none;
  }
}
</style>
